import React from "react";
import { Dialog } from 'primereact/dialog';

const ModalTerms = ({
    open = false,
    onClose = () => console.log('onClose')
}) => {
    return (
        <Dialog
            visible={open}
            style={{ width: '90%', maxWidth: '600px' }}
            onHide={() => onClose()}
            draggable={false}
            resizable={false}
            closable={true}
            header="ข้อกำหนดและเงื่อนไข"
            className="terms-modal"
            headerClassName="terms-modal-header"
        >
            <div className="terms-content">
                <p className="terms-title">รายละเอียดและเงื่อนไขการเพิ่มเพื่อนบัญชี LINE Official Account S-Mom Club Gold</p>

                <div className="terms-section">
                    <p className="terms-section-title">1. สิทธิพิเศษในการเพิ่มเพื่อนบัญชี LINE Official Account S-Mom Club Gold</p>

                    <div className="terms-subsection">
                        <p>
                            1.1 ผู้ที่ทําการเพิ่มเพื่อนบัญชี LINE Official Account S-Mom Club Gold ("บัญชี LINE OA") โดยการสแกน QR Code ณ ร้านค้า ผ่านการ นําเสนอโดยพนักงานตัวแทนจําหน่ายจากบริษัท เนสท์เล่ (ไทย) จํากัด ("บริษัทฯ") ตั้งแต่วันที่ 1 กรกฎาคม 2568 เป็นต้นไป โดยเป็นไปตามข้อกําหนดและ เงื่อนไขอื่นๆ ที่กําหนดด้านล่างนี้ จะได้รับสินค้าตัวอย่าง S-26 Gold Pro UHT หรือ S-26 Gold UHT สูตร 3 หรือ S-26 Omega+ UHT หรือ Carnation UHT จํานวน 1 ชิ้น ต่อ 1 บัญชี LINE โดยจะได้รับสินค้าตัวอย่างจากพนักงานตัวแทนจําหน่าย ณ หน้าร้านค้า
                        </p>
                    </div>

                    <div className="terms-subsection">
                        <p>1.2 สิทธิประโยชน์อื่นๆ <br></br>
                            ผู้ที่ทําการเพิ่มเพื่อนบัญชี LINE OA จะได้รับข้อมูลความรู้ เคล็ดลับการเลี้ยงดูบุตร การดูแลสุขภาพลูกน้อยเบื้องต้น รวมถึงการให้คําแนะนํา เรื่องการเลี้ยงลูกด้วยนมแม่ตามหลัก WHO เพื่อช่วยรณรงค์ และส่งเสริมการให้นมแม่ให้ยาวนาน และให้ความรู้และคําแนะนําที่จัดทําขึ้นเป็นกรณีพิเศษโดยเฉพาะ (Personalization) แก่ผู้ที่ทําการเพิ่มเพื่อนบัญชี LINE OA
                        </p>
                    </div>
                </div>

                <div className="terms-section">
                    <p className="terms-section-title">2. ข้อกำหนดและเงื่อนไขอื่นๆ</p>

                    <div className="terms-subsection">
                        <p>2.1 ผู้ที่ทำการเพิ่มเพื่อนบัญชี LINE OA ต้องมีอายุตั้งแต่ 20 ปีขึ้นไป</p>
                        <p>2.2 ผู้ที่ทำการเพิ่มเพื่อนบัญชี LINE OA ตกลงและรับทราบว่า การเพิ่มเพื่อนนี้จะต้องมีการเปิดเผยข้อมูลบัญชี LINE (LINE UID) รวมทั้งข้อมูลที่ได้ทำการ ให้ครบถ้วนแก่บริษัทฯ และเพื่อให้บริษัทฯ ดำเนินการอันเกี่ยวข้องกับกิจกรรมนี้</p>
                        <p>2.3 บริษัทฯ ขอสงวนสิทธิ์มอบสินค้าตัวอย่างให้เฉพาะผู้ที่เพิ่มเพื่อนบัญชี LINE OA และไม่เป็นผู้ที่มีบุตรอายุไม่เกิน 1 ปี เท่านั้น</p>
                        <p>2.4 ขอสงวนสิทธิ์มอบสินค้าตัวอย่าง S-26 Gold Pro UHT หรือ S-26 Gold UHT สูตร 3 หรือ S-26 Omega+ UHT หรือ Carnation UHT สูงสุดเพียง 1 ชิ้น ต่อ 1  บัญชี LINE</p>
                        <p>2.5 สินค้าตัวอย่างอาจมีการเปลี่ยนแปลงตามความเหมาะโดยไม่ต้องแจ้งให้ทราบล่วงหน้า</p>
                        <p>2.6 ผู้ที่ทำการเพิ่มเพื่อนบัญชี LINE OA ได้อ่านและรับทราบ ประกาศความเป็นส่วนตัวของบริษัทฯ แล้วที่ https://www.s-momclub.com/privacy-policy</p>
                        <p>2.7 ขอสงวนสิทธิ์ในการเปลี่ยนแปลงข้อกำหนดและเงื่อนไขตามความเหมาะสม โดยบริษัทฯ ไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า</p>
                        <p>2.8 สินค้าตัวอย่าง และสิทธิประโยชน์อื่นๆ ไม่สามารถแลกเปลี่ยนเป็นเงินสด ส่วนลด หรือของอย่างอื่นได้ และไม่สามารถโอนสิทธิ์ให้แก่บุคคลอื่นได้</p>
                        <p>2.9 ขอสงวนสิทธิในการเปลี่ยนแปลงข้อกำหนดและเงื่อนไขตามความเหมาะสม โดยบริษัทฯ ไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า</p>
                        <p>2.10 หากมีข้อสงสัยเพิ่มเติม สามารถติดต่อได้ที่แผนกลูกค้าสัมพันธ์ S-MOM CLUB โทร.02-640-2288</p>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default ModalTerms 